export { default as Admin } from './Admin';



// WEBPACK FOOTER //
// ./src/components/Admin/index.js